import { useState, useEffect } from "react";
import { getFeatureFlag } from "./getFeatureFlag";
import * as bus from "@sinch/bus";
export const useFeatureFlag = (...args) => {
    const initFeatureFlag = getFeatureFlag(...args);
    const [featureFlag, setFeatureFlag] = useState(initFeatureFlag);
    useEffect(() => {
        bus.listen(() => {
            setFeatureFlag(getFeatureFlag(...args));
        }, bus.isFlagsConfigChangedMessage);
    });
    return featureFlag;
};
